import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { serviceGroups } from '../data/services';
export function ServicesSection() {
  const [activeId, setActiveId] = useState(serviceGroups[0].id);
  const active = serviceGroups.find(group => group.id === activeId) ?? serviceGroups[0];
  return <section id="services" className="bg-ivory py-24 lg:py-32" data-id="element-142" data-mp="26k0dgls1ic2q">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10" data-id="element-143" data-mp="26ifkv1pad37i">
        <SectionHeading eyebrow="Services" title={<>
              Four disciplines, <span className="italic text-brass" data-id="element-145" data-mp="1xleyf0ls1f6p">one standard</span>.
            </>} description="From a single mirror to a full home of inset cabinetry, the work is measured, templated, and finished by the same hands every time." data-id="element-144" data-mp="2bc1xitvg973b" />

        <div className="mt-14 grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-146" data-mp="1slagd6580ced">
          <div role="tablist" aria-label="Service categories" className="border-t border-ivory-300" data-id="element-147" data-mp="2pnaxr3uoqfkg">
            {serviceGroups.map(group => {
            const isActive = group.id === active.id;
            return <button key={group.id} role="tab" id={`tab-${group.id}`} aria-selected={isActive} aria-controls={`panel-${group.id}`} onClick={() => setActiveId(group.id)} className={`group flex w-full items-baseline gap-6 border-b border-ivory-300 py-7 text-left transition-colors ${isActive ? 'bg-ivory-200/60' : 'hover:bg-ivory-200/40'}`} data-id="element-148" data-mp="2yo95nx88v78b">
                  <span className={`pl-4 font-mono text-[11px] tracking-[0.2em] ${isActive ? 'text-brass' : 'text-muted-foreground'}`} data-id="element-149" data-mp="2awtztuh9e7sb">
                    {group.eyebrow}
                  </span>
                  <span className={`font-display text-2xl leading-tight sm:text-3xl ${isActive ? 'text-ink' : 'text-ink/55 group-hover:text-ink'}`} data-id="element-150" data-mp="3iaxpgwh1ynby">
                    {group.title}
                  </span>
                  <span className={`ml-auto mr-4 h-px w-8 shrink-0 transition-all ${isActive ? 'w-14 bg-brass' : 'bg-ivory-300'}`} aria-hidden="true" data-id="element-151" data-mp="vqxxkiy8f82" />
                </button>;
          })}
          </div>

          <motion.div key={active.id} role="tabpanel" id={`panel-${active.id}`} aria-labelledby={`tab-${active.id}`} initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45,
          ease: [0.22, 1, 0.36, 1]
        }} className="bg-white" data-id="element-152" data-mp="39ahphwzipybu">
            <img src={active.image} alt={active.title} width={1536} height={2048} loading="lazy" decoding="async" className="h-64 w-full object-cover lg:h-80" data-id="element-153" data-mp="2e2p4pfco16qh" />
            <div className="p-8 lg:p-10" data-id="element-154" data-mp="24a1cyz0jlsym">
              <h3 className="font-display text-3xl text-ink" data-id="element-155" data-mp="1zc9jw1o5w0su">{active.title}</h3>
              <p className="mt-4 leading-relaxed text-muted-foreground" data-id="element-156" data-mp="1uepty4i3pzl2">{active.description}</p>
              <ul className="mt-8 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-157" data-mp="1qc39ionrfgxw">
                {active.items.map(item => <li key={item} className="flex items-start gap-3 text-sm text-ink/80" data-id="element-158" data-mp="1lekymsq6mrn9">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-brass" aria-hidden="true" data-id="element-159" data-mp="1gf8cka74xolq" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}